export default __webpack_public_path__ + "static/media/mandiLogoMain.5149a072.webp";